import { render, staticRenderFns } from "./ProductsToWarehouse.vue?vue&type=template&id=8daa4cd2"
import script from "./ProductsToWarehouse.vue?vue&type=script&lang=js"
export * from "./ProductsToWarehouse.vue?vue&type=script&lang=js"
import style0 from "./ProductsToWarehouse.vue?vue&type=style&index=0&id=8daa4cd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports